export default __webpack_public_path__ + "static/media/logoNVIDIA_LastOld.d15308a9.png";